export {default as DeptManagementSummary} from './Encurso'